import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
    accessState,
    accountBlockedState,
    accountKeyState,
    billingState,
    businessState,
    distanceFormatMatchesBrowserState,
    distanceFormatState,
    emailVerifiedState,
    hardLoginTsState,
    iconState,
    inviteCodesState,
    isAmPmState,
    isDispatchPlanState,
    isImperialState,
    isLocationPlanState,
    isSelfAdminOrCompanyState,
    isSelfAdminState,
    isSelfCompanyState,
    isSelfOperatorState,
    isSelfWorkerState,
    languageMatchesBrowserState,
    languageState,
    loginTsState,
    nameState,
    passwordState,
    roleState,
    slackTeamIdState,
    supportSessionState,
    timeFormatMatchesBrowserState,
    timeFormatState,
    timestampsState,
    timezoneMatchesBrowserState,
    timezoneState,
    tokenState,
    uidState,
    usernameState
} from "../states/accountState";
import { useCallback } from "react";

export default function useAccount() {
    const [hardLoginTs, setHardLoginTs] = useRecoilState(hardLoginTsState);
    const [username, setUsername] = useRecoilState(usernameState);
    const [password, setPassword] = useRecoilState(passwordState);
    const [emailVerified, setEmailVerified] = useRecoilState(emailVerifiedState);
    const [name, setName] = useRecoilState(nameState);
    const [role, setRole] = useRecoilState(roleState);
    const [uid, setUid] = useRecoilState(uidState);
    const [token, setToken] = useRecoilState(tokenState);
    const [accountKey, setAccountKey] = useRecoilState(accountKeyState);
    const [access, setAccess] = useRecoilState(accessState);
    const [icon, setIcon] = useRecoilState(iconState);
    const setLoginTs = useSetRecoilState(loginTsState);
    const [timeFormat, setTimeFormat] = useRecoilState(timeFormatState);
    const [distanceFormat, setDistanceFormat] = useRecoilState(distanceFormatState);
    const [language, setLanguage] = useRecoilState(languageState);
    const [timezone, setTimezone] = useRecoilState(timezoneState);
    const setInviteCodes = useSetRecoilState(inviteCodesState);
    const [billing, setBilling] = useRecoilState(billingState);
    const [slackTeamId, setSlackTeamId] = useRecoilState(slackTeamIdState);
    const [supportSession, setSupportSession] = useRecoilState(supportSessionState);
    const isBlocked = useRecoilValue(accountBlockedState);
    const setTimestamps = useSetRecoilState(timestampsState);
    const [isBusiness, setBusiness] = useRecoilState(businessState);
    const isAmPm = useRecoilValue(isAmPmState);
    const isImperial = useRecoilValue(isImperialState);
    const isSelfAccount = useCallback((id: string) => {
        return id === uid;
    }, [uid]);
    const isSelfCompany = useRecoilValue(isSelfCompanyState);
    const isSelfWorker = useRecoilValue(isSelfWorkerState);
    const isSelfOperator = useRecoilValue(isSelfOperatorState);
    const isSelfAdmin = useRecoilValue(isSelfAdminState);
    const isSelfAdminOrCompany = useRecoilValue(isSelfAdminOrCompanyState);
    const timezoneMatchesBrowser = useRecoilValue(timezoneMatchesBrowserState);
    const timeFormatMatchesBrowser = useRecoilValue(timeFormatMatchesBrowserState);
    const distanceFormatMatchesBrowser = useRecoilValue(distanceFormatMatchesBrowserState);
    const languageMatchesBrowser = useRecoilValue(languageMatchesBrowserState);
    const isLocationPlan = useRecoilValue(isLocationPlanState);
    const isDispatchPlan = useRecoilValue(isDispatchPlanState);

    return {
        username,
        setUsername,
        password,
        setPassword,
        name,
        setName,
        role,
        setRole,
        uid,
        setUid,
        token,
        setToken,
        access,
        setAccess,
        icon,
        setIcon,
        setLoginTs,
        timeFormat,
        setTimeFormat,
        isAmPm,
        distanceFormat,
        setDistanceFormat,
        isImperial,
        timezone,
        setTimezone,
        language,
        setLanguage,
        setInviteCodes,
        isSelfAccount,
        billing,
        setBilling,
        isSelfCompany,
        isSelfAdmin,
        isSelfWorker,
        isSelfOperator,
        isSelfAdminOrCompany,
        isBlocked,
        accountKey,
        setAccountKey,
        slackTeamId,
        setSlackTeamId,
        supportSession,
        setSupportSession,
        hardLoginTs,
        setHardLoginTs,
        timezoneMatchesBrowser,
        timeFormatMatchesBrowser,
        distanceFormatMatchesBrowser,
        languageMatchesBrowser,
        isBusiness,
        setBusiness,
        setTimestamps,
        isLocationPlan,
        isDispatchPlan,
        emailVerified,
        setEmailVerified,
    }
}

export function useUnstableAccount() {
    const loginTs = useRecoilValue(loginTsState);
    const inviteCodes = useRecoilValue(inviteCodesState);
    const timestamps = useRecoilValue(timestampsState);

    return {
        loginTs,
        inviteCodes,
        timestamps,
    }
}
